import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ChevronRightIcon, FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PilatesHero() {
  const reduceMotion = useReducedMotion();
  return <section className="relative overflow-hidden bg-padel-dark px-4 pb-14 pt-10 sm:pb-20 sm:pt-16" data-id="element-203" data-mp="2gthsf7a2o2xm">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/8ece9af6-cee3-488a-abbe-c91f06710bec.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-204" data-mp="2crw8j1z4eodx" />
      <div className="absolute inset-0 bg-padel-dark/80" aria-hidden="true" data-id="element-205" data-mp="232urr9kr42yw" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-padel-dark to-transparent" aria-hidden="true" data-id="element-206" data-mp="1y3rljlt1bqpc" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-207" data-mp="1t5zv6w81gcn9">
        {/* Marca */}
        <FadeIn data-id="element-208" data-mp="1p4o3ml5lthcf">
          <span className="inline-flex items-center gap-2 rounded-full border border-padel-muted bg-padel-surface/90 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-gray-300" data-id="element-209" data-mp="3qkke22vbx696">
            <span className="text-padel-lime" data-id="element-210" data-mp="3gmecxnhck45d">💪</span> Stock Digital™
          </span>
        </FadeIn>

        {/* Título */}
        <FadeIn delay={0.08} data-id="element-211" data-mp="3lkfxydyc2djh">
          <h1 className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-212" data-mp="3llr1ccnv9ja2">
            Resolvé todas tus clases de pádel{' '}
            <span className="block text-padel-lime drop-shadow-[0_0_30px_rgba(197,255,61,0.28)]" data-id="element-213" data-mp="i3z0s9vnzr09">
              en 5 minutos
            </span>
          </h1>
        </FadeIn>

        {/* Subtítulo */}
        <FadeIn delay={0.14} data-id="element-214" data-mp="84qb3t7u0yjp">
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-gray-300 sm:text-lg" data-id="element-215" data-mp="885rr0h5mfn8">
            Planificaciones, ejercicios, seguimiento y negocio listos para usar.
            Sin improvisar y sin perder los domingos.
          </p>
        </FadeIn>

        {/* Mockup */}
        <FadeIn delay={0.2} className="w-full" data-id="element-216" data-mp="zfw3gnvxzbja">
          <motion.div animate={reduceMotion ? undefined : {
          y: [0, -10, 0]
        }} transition={reduceMotion ? undefined : {
          duration: 5,
          ease: 'easeInOut',
          repeat: Infinity
        }} className="relative mx-auto mt-8 w-full max-w-[19rem] sm:max-w-sm" data-id="element-217" data-mp="uegkr2h8lh42">
            <div className="absolute inset-6 rounded-full bg-padel-lime/25 blur-3xl" aria-hidden="true" data-id="element-218" data-mp="gl8qf31ru7io" />
            <img src="https://cdn.magicpatterns.com/uploads/k8DuDoNSCcuTNBKRMxRtk8/ChatGPT_Image_23_jul_2026,_03_23_57_p.m..png" alt="Método Pro-Pádel: libro, ejercicios e imágenes de golpes" className="relative w-full object-contain drop-shadow-[0_25px_50px_rgba(0,0,0,0.6)]" data-id="element-219" data-mp="6ocgcsw85dc0" />
          </motion.div>
        </FadeIn>

        {/* Botón de oferta */}
        <FadeIn delay={0.26} className="w-full" data-id="element-220" data-mp="24lw059y87uzs">
          <button type="button" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="mx-auto mt-8 flex w-full max-w-md flex-col items-center justify-center rounded-2xl bg-padel-lime px-6 py-4 font-display text-padel-dark shadow-[0_0_35px_rgba(197,255,61,0.28)] transition-transform hover:scale-[1.02] active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-221" data-mp="24j02znu7dace">
            <span className="flex items-center gap-2 text-xl font-black leading-none sm:text-2xl" data-id="element-222" data-mp="1zlq65n4hhwej">
              QUIERO MI PACK AHORA
              <ChevronRightIcon className="h-6 w-6" strokeWidth={3} data-id="element-223" data-mp="3610luynynpid" />
            </span>
            <span className="mt-1.5 text-sm font-bold text-padel-dark/75 sm:text-base" data-id="element-224" data-mp="3b0dgi5l2q0vi">
              Desde $19.990 ARS
            </span>
          </button>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-gray-300 sm:text-sm" data-id="element-225" data-mp="nuk3mhim0v9d">
            <span className="inline-flex items-center gap-1.5" data-id="element-226" data-mp="wtnmbkdv78nc">
              <FileTextIcon className="h-4 w-4 text-padel-lime" data-id="element-227" data-mp="ruapq7x6yn7k" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-228" data-mp="16rbk6j6row9q">
              <ZapIcon className="h-4 w-4 text-padel-lime" data-id="element-229" data-mp="16pqrkz40jnei" />
              Acceso en 5 min
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-230" data-mp="11qe2s8tl069a">
              <BookOpenIcon className="h-4 w-4 text-padel-lime" data-id="element-231" data-mp="1fillwxrxzypi" />
              Todos los niveles
            </span>
          </div>

          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-semibold text-gray-500 sm:text-xs" data-id="element-232" data-mp="1bkefavr70ds1">
            <span data-id="element-233" data-mp="1kjrfextffq03">🛡️ Garantía 7 días</span>
            <span data-id="element-234" data-mp="1kkt1ryfw7yx4">🔒 Pago seguro</span>
            <span data-id="element-235" data-mp="2451fj06ueovg">💳 Mercado Pago</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}